import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  height: 50px;\n'], ['\n  height: 50px;\n']);

import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { utils, translations, styles } from 'gipsy-misc';
import { HeaderContainer, Title, Star, Description } from './Common';
import NeedReviewAsReviewer from './NeedReviewAsReviewer';
import ReviewedReviewAsReviewer from './ReviewedReviewAsReviewer';
import ReviewersStatus from './ReviewersStatus';

var Review = function (_PureComponent) {
  _inherits(Review, _PureComponent);

  function Review() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Review);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Review.__proto__ || Object.getPrototypeOf(Review)).call.apply(_ref, [this].concat(args))), _this), _this.renderWillNeedReviewAsReviewer = function () {
      return React.createElement(
        Fragment,
        null,
        React.createElement(TopLayer, null),
        React.createElement(
          HeaderContainer,
          null,
          React.createElement(
            Title,
            null,
            translations.review.header.willNeedReviewAsReviewer.title
          ),
          React.createElement(
            Description,
            null,
            translations.review.header.willNeedReviewAsReviewer.description
          )
        )
      );
    }, _this.renderNeedReviewAsReviewer = function () {
      return React.createElement(NeedReviewAsReviewer, {
        review: _this.props.review,
        reviewers: _this.props.reviewers,
        onChange: _this.props.onChange,
        onChangeReview: _this.props.onChangeReview,
        handleAPIError: _this.props.handleAPIError,
        progressPending: _this.props.progressPending,
        progressSuccess: _this.props.progressSuccess,
        progressError: _this.props.progressError,
        approveReview: _this.props.approveReview,
        reopenReview: _this.props.reopenReview
      });
    }, _this.renderReopenedReviewAsReviewer = function () {
      return React.createElement(
        HeaderContainer,
        null,
        React.createElement(
          Title,
          null,
          React.createElement(Star, { icon: 'Star', fill: styles.colors.textDarkColor, size: 16 }),
          React.createElement(
            'div',
            null,
            translations.review.header.reopenedReviewAsReviewer.title
          )
        ),
        React.createElement(ReviewersStatus, { reviewers: _this.props.reviewers })
      );
    }, _this.renderReviewedReviewAsReviewer = function () {
      return React.createElement(ReviewedReviewAsReviewer, {
        review: _this.props.review,
        reviewers: _this.props.reviewers,
        onChange: _this.props.onChangeReview
      });
    }, _this.renderNeedReviewAsAssignee = function () {
      return React.createElement(
        HeaderContainer,
        null,
        React.createElement(
          Title,
          null,
          React.createElement(Star, { icon: 'Star', fill: styles.colors.textDarkColor, size: 16 }),
          React.createElement(
            'div',
            null,
            translations.review.header.needReviewAsAssignee.title
          )
        ),
        React.createElement(ReviewersStatus, { reviewers: _this.props.reviewers })
      );
    }, _this.renderReopenedReviewAsAssignee = function () {
      return React.createElement(
        HeaderContainer,
        null,
        React.createElement(
          Title,
          null,
          React.createElement(Star, { icon: 'Star', fill: styles.colors.textDarkColor, size: 16 }),
          React.createElement(
            'div',
            null,
            translations.review.header.reopenedReviewAsAssignee.title
          )
        ),
        React.createElement(ReviewersStatus, { reviewers: _this.props.reviewers })
      );
    }, _this.renderReviewedReviewAsAssignee = function () {
      return React.createElement(
        HeaderContainer,
        null,
        React.createElement(
          Title,
          null,
          React.createElement(Star, { icon: 'Star', fill: styles.colors.textDarkColor, size: 16 }),
          React.createElement(
            'div',
            null,
            translations.review.header.reviewedReviewAsAssignee.title
          )
        ),
        React.createElement(ReviewersStatus, { reviewers: _this.props.reviewers })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Review, [{
    key: 'render',
    value: function render() {
      var reviewHeaderType = this.props.reviewHeaderType;


      switch (reviewHeaderType) {
        case utils.taskpanel.willNeedReviewAsReviewer:
          return null;
        case utils.taskpanel.reopenedReviewAsReviewer:
          return this.renderReopenedReviewAsReviewer();
        case utils.taskpanel.needReviewAsReviewer:
          return this.renderNeedReviewAsReviewer();
        case utils.taskpanel.reviewedReviewAsReviewer:
          return this.renderReviewedReviewAsReviewer();
        case utils.taskpanel.needReviewAsAssignee:
          return this.renderNeedReviewAsAssignee();
        case utils.taskpanel.reviewedReviewAsAssignee:
          return this.renderReviewedReviewAsAssignee();
        case utils.taskpanel.reopenedReviewAsAssignee:
          return this.renderReopenedReviewAsAssignee();
        default:
          return null;
      }
    }
  }]);

  return Review;
}(PureComponent);

Review.propTypes = {
  review: PropTypes.object,
  reviewers: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  onChangeReview: PropTypes.func.isRequired,
  handleAPIError: PropTypes.func,
  progressPending: PropTypes.func,
  progressSuccess: PropTypes.func,
  progressError: PropTypes.func,
  approveReview: PropTypes.func,
  reopenReview: PropTypes.func
};


var TopLayer = styled.div(_templateObject);
export default Review;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/components/Header/Review/index.js
// module id = 1096
// module chunks = 0